export default "__VITE_ASSET__ac36b711__"